<template>
  <section>
    <PageTitle>Opret nyt indholdsstof</PageTitle>
    <section>
      <CreateSubstance
        :default-form="defaultForm"
        @created="onCreated"
      />
    </section>
  </section>
</template>

<script>
import CreateSubstance from '../../components/Forms/Substances/CreateSubstance.vue';

export default {
    name: 'CreateSubstanceContainer',
    components: { CreateSubstance },
    props: {
        defaultForm: { type: Object, default: null },
    },
    methods: {
        onCreated(payload) {
            this.$router.push({
                name: 'substances.single',
                params: { id: payload.info.id },
                query: { date: window.moment.utc(payload.info.publishDate).local().format('YYYY-MM-DD HH:mm') },
            });
        },
    },
};
</script>
